module.exports = __webpack_public_path__ + "img/enterpreneurship_3.b2eb4cdd.jpg";